import React, { useEffect } from 'react';
import '../../../../css/huerto/scoringBubble.css';
import 'tippy.js/dist/tippy.css'; // optional for styling

const ScoringBubble = ({ contracts, position, color, bubbleClick }) => {
    let positionColor = '';
    let _color = '';
    switch (color) {
        case 1:
            positionColor = 'AA';
            _color = '#25CC99';
            break;
        case 2:
            positionColor = 'BA';
            _color = '#9BCC25';
            break;
        case 3:
            positionColor = 'CA';
            _color = '#FF8557';
            break;
        case 4:
            positionColor = 'AB';
            _color = '#9BCC25';
            break;
        case 5:
            positionColor = 'BB';
            _color = '#FFBE48';
            break;
        case 6:
            positionColor = 'CB';
            _color = '#FF8557';
            break;
        case 7:
            positionColor = 'AC';
            _color = '#FF8557';
            break;
        case 8:
            positionColor = 'BC';
            _color = '#FF8557';
            break;
        case 9:
            positionColor = 'CC';
            _color = '#FF5757';
            break;
        case 10:
            positionColor = 'CR';
            _color = '#FF5757';
            break;
        case 11:
            positionColor = 'BR';
            _color = '#FFBE48';
            break;
        case 12:
            positionColor = 'AR';
            _color = '#25CC99';
            break;
        default:
            break;
    }

    return (
        <div
            className={
                'scoringBubble position-' +
                position +
                ' color-' +
                positionColor +
                ' '
            }
            onClick={bubbleClick}
        >
            <span> {contracts != '' ? contracts : '0'} </span>
        </div>
    );
};

export default ScoringBubble;
